export function ContentContainer({ children }) {
  return (
    <div className="w-full row justify-content-center col-span-full">
      <div className="px-0 sm:px-5">{children}</div>
    </div>
  );
}
